import { number, string, date } from 'yup'

export const validationMessage = {
  required: '必須です。',
  passwordMatches: '英数字8〜20文字で入力してください。（英字大文字、小文字、数字それぞれ1文字以上を使用してください）',
  notMatchNewPassword: '新しいパスワードが一致しません。',
  email: 'メールアドレスを入力してください。',
  positiveNum: '0以上の数値を入力してください。',
  enterItem: '項目を入力してください。'
}

export const myValidationSchemaObj = {
  requiredString: string()
    .trim()
    .required(validationMessage.required),
  requiredEmail: string()
    .trim()
    .required(validationMessage.required)
    .email(validationMessage.email)
    .max(100, '100文字以内で入力してください。'),
  password: string()
    .trim()
    .required(validationMessage.required)
    .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\da-zA-Z]{8,20}$/, validationMessage.passwordMatches),
  requiredPositiveNum: number()
    .required(validationMessage.required)
    .min(0, validationMessage.positiveNum)
    .nullable()
    .transform((value, originalValue) => String(originalValue).trim() === '' ? null : value),
  maxString: (max: number) => {
    return string()
      .trim()
      .required(validationMessage.required)
      .max(max, `${max}文字以内で入力してください。`)
  },
  fixedLengthNumber: (len: number) => {
    return string()
      .trim()
      .required(validationMessage.required)
      .matches(new RegExp(`^\\d{${len}}$`), `${len}桁の数字で入力してください`)
  },
  nullableMaxString: (max: number) => {
    return string()
      .trim()
      .nullable()
      .max(max, `${max}文字以内で入力してください。`)
  },
  requiredDate: date().required(validationMessage.required)
    .nullable()
    .transform((value, originalValue) => String(originalValue).trim() === '' ? null : value),
  requiredIfFieldEquals: (fieldName: string, expectedValue: string) =>
    string().trim().when(fieldName, {
      is: (val: string) => val === expectedValue,
      then: (schema) => schema.required(validationMessage.required),
      otherwise: (schema) => schema.notRequired()
    }),
  fixedLengthNumberIfFieldEquals: (fieldName: string, expectedValue: string, len: number) =>
    string().trim().when(fieldName, {
      is: (val: string) => val === expectedValue,
      then: (schema) => schema.trim().required().matches(new RegExp(`^\\d{${len}}$`), `${len}桁の数字で入力してください`),
      otherwise: (schema) => schema.notRequired()
    }),
  requiredStringIfFieldNotEquals: (fieldName: string, notValue: string) =>
    string().trim().when(fieldName, {
      is: (val: string) => val !== notValue,
      then: (schema) => schema.required(validationMessage.required),
      otherwise: (schema) => schema.notRequired()
    }),
  requiredNumberIfFieldNotEquals: (fieldName: string, notValue: string) =>
    number()
      .transform((_, originalValue) =>
        originalValue === '' || originalValue == null ? null : Number(originalValue)
      )
      .nullable()
      .typeError(validationMessage.positiveNum)
      .min(0, validationMessage.positiveNum)
      .when(fieldName, {
        is: (val: string) => val !== notValue,
        then: (schema) => schema.required(validationMessage.required),
        otherwise: (schema) => schema.notRequired()
      }),
  requiredIfTwoFields: (fieldName1: string, expectedValue1: string, fieldName2: string, excludedValue2: string) =>
    string().trim().when([fieldName1, fieldName2], {
      is: (val1: string, val2: string) => val1 === expectedValue1 && val2 !== excludedValue2,
      then: (schema) => schema.required(validationMessage.required),
      otherwise: (schema) => schema.notRequired()
    })
}

export function colorValidator (value: string | null): boolean {
  if (!value) {
    return true
  }
  return ['success', 'warning', 'danger', 'info', 'secondary', 'primary'].indexOf(value) !== -1
}
